import { useSelector } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import { getModuleDataByModuleName } from '@wix/da-gruser-shared/pkg/redux/selectors/modules';
import { GallectionType } from '../../../../../types/gallection';
import { AppState } from '../../../../../types/store';
import { getProfileGruser, getProfileOwnerStat } from '../../../../selectors/users';
import { getGallectionSectionType } from '../../../../selectors/gallectionSection';

export type GalleryPromoType = 'subscriptions' | 'originals';

interface GalleryPromoUpsell {
  showPromo: boolean;
  promoType: GalleryPromoType;
  promoDeviation: PapiDeviation | undefined;
  promoCount: number;
}

export function useGalleryUpsell(): GalleryPromoUpsell {
  const gallectionType = useSelector(getGallectionSectionType);
  const isGallery = gallectionType === GallectionType.GALLERY;
  const tierCount: number =
    useSelector((state: AppState) => getProfileOwnerStat(state, 'tiers')) ?? 0;
  const originalsCount: number =
    useSelector((state: AppState) => getProfileOwnerStat(state, 'originals')) ?? 0;
  const gruser = useSelector(getProfileGruser);
  const foldersModuleData = useSelector((state: any) =>
    getModuleDataByModuleName(state, gruser, 'folders')
  );
  const promoDeviation: PapiDeviation | undefined = foldersModuleData?.promo;

  const isOriginalsPromo = !!promoDeviation?.originals;
  const promoType: GalleryPromoType = isOriginalsPromo ? 'originals' : 'subscriptions';
  const promoCount = isOriginalsPromo ? originalsCount : tierCount;

  // Must be gallery section, have promo, and promo be either tier or originals
  const showPromo =
    isGallery && !!promoDeviation && (promoDeviation.tier !== undefined || isOriginalsPromo);

  return { showPromo, promoType, promoDeviation, promoCount };
}
